module.exports = __webpack_public_path__ + "static/media/tetrix_kraussi.49228119.jpg";